package br.com.vvrefeicoes.portal.domain.model

data class CustomerSatisfaction(
    val id: String,
    val date: String,
    val managerName: String,
    val location: String,
    val meals: Int,
    val businessDays: Int,
    val totalClients: Int,
    val excellent: Int,
    val good: Int,
    val regular: Int,
    val bad: Int,
    val totalVotes: Int,
    val goalPercent: Double,
    val participationPercent: Double,
    val achieved: Boolean,
)
